/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class WalletPassPublicService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Download Apple Wallet pass using one-time token
   * Validates a one-time token and streams the .pkpass file for Apple Wallet. Token can only be used once and expires after 48 hours.
   * @returns any Apple Wallet pass file (.pkpass)
   * @throws ApiError
   */
  public getApplePass({
    token,
  }: {
    /**
     * One-time download token
     */
    token: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/wallet-pass/apple/{token}',
      path: {
        'token': token,
      },
      errors: {
        422: `Invalid or expired token`,
      },
    });
  }
  /**
   * Add to Google Wallet using one-time token
   * Validates a one-time token and redirects to Google Wallet save URL. Token can only be used once and expires after 48 hours.
   * @returns any
   * @throws ApiError
   */
  public getGooglePass({
    token,
  }: {
    /**
     * One-time download token
     */
    token: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/wallet-pass/google/{token}',
      path: {
        'token': token,
      },
      errors: {
        302: `Redirects to Google Wallet save URL`,
        422: `Invalid or expired token`,
      },
    });
  }
}
